import { css } from '@/styled-system/css';

export const modalFooterStyles = css.raw({
  flexGrow: 0,
  flexShrink: 0,
  flexBasis: 'auto',
  display: 'flex',
  justifyContent: 'flex-end',
  paddingBlock: 'Modal.Footer.padding.vert',
  paddingInline: 'Modal.Footer.padding.horz',
});
